import { render, staticRenderFns } from "./TableExpandableData.vue?vue&type=template&id=29c612b3"
import script from "./TableExpandableData.vue?vue&type=script&lang=js"
export * from "./TableExpandableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports